import { gql } from "@apollo/client/core";

export default gql`
    mutation DeletePreventionCategory($id: ID!) {
        deletePreventionCategory(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
